import { render } from "./ChildArchiveDialog.vue?vue&type=template&id=e99303f4&scoped=true"
import script from "./ChildArchiveDialog.vue?vue&type=script&lang=js"
export * from "./ChildArchiveDialog.vue?vue&type=script&lang=js"

import "./ChildArchiveDialog.vue?vue&type=style&index=0&id=e99303f4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e99303f4"]])

export default __exports__